<section>
  <mode-capra-search-input
    class="search-input"
    data-test="field-search-input"
    placeholder="Search fields..."
    size="mini"
    [text]="searchTerm$ | async"
    (textChange)="onSearchTermChanged($event)"
  >
  </mode-capra-search-input>
  <ng-container *ngIf="isExplorishOrViz">
    <capra-icon-button
      class="add-calc-btn"
      icon="illo-mini-cal-field-add"
      size="medium"
      aria-label="Chart options menu"
      data-test="add-calc-field-button"
      (click)="onCreateCalcField()"
      capraTooltip
      [tooltipContent]="tooltipContent"
      tooltipPlacement="left"
      [tooltipInteractive]="tooltipInteractive"
      [tooltipDelay]="tooltipDelay"
      [tooltipAppendTo]="tooltipAppendTo"
      tooltipSize="regular-thin"
      modeTrackClick
    ></capra-icon-button>
  </ng-container>
</section>
